"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _big_cat_sort = require("@/api/big_cat_sort");

// const state = {
//   name: '',
//   sex: ''
// }
// const mutations = {
//   SET_NAME: (state, name) => {
//     state.name = name
//   },
//   SET_SEX: (state, sex) => {
//     state.sex = sex
//   }
// }
var actions = {
  edit: function edit(_ref, catInfo) {
    var commit = _ref.commit;
    // const { name, sex } = catInfo
    return new Promise(function (resolve, reject) {
      (0, _big_cat_sort.edit)(catInfo).then(function (response) {
        var data = response.data; // commit('SET_NAME', name)

        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
var _default = {
  namespaced: true,
  // state,
  // mutations,
  actions: actions
};
exports.default = _default;